import { DEFAULT_HOLDOUT_STATE } from './DEFAULT_HOLDOUT_STATE';
import { getOnboardingHoldoutState } from './getOnboardingHoldoutState';
import { persistState } from './persistState';

/**
 * Record that the user completed the onboarding flow (e.g. selected a prompt).
 * They will never be shown onboarding again. Keeps existing exposure count;
 * completion is separate from max-exposure holdout.
 */
export function recordOnboardingCompletedForHoldout(): void {
	const state = getOnboardingHoldoutState() ?? DEFAULT_HOLDOUT_STATE;

	persistState({
		...state,
		lastSeenAt: Date.now(),
		onboardingCompleted: true,
	});
}
